import React from 'react';

import { FormattedMessage, useIntl } from '../../../../util/reactIntl';
import { NamedLink } from '../../../../components';
import supplyImage from '../../../../assets/homepage-supply-mobile.jpg';

import css from './SectionHomeSupply.module.css';

const SectionHomeSupply = () => {
  const intl = useIntl();

  return (
    <section className={css.root}>
      <img
        className={css.image}
        src={supplyImage}
        alt={intl.formatMessage({ id: 'LandingPage.mobileHome.supply.imageAlt' })}
      />
      <div className={css.shade} />
      <div className={css.tx}>
        <b className={css.headline}>
          <FormattedMessage id="LandingPage.mobileHome.supply.headline" />
        </b>
        <p className={css.body}>
          <FormattedMessage id="LandingPage.mobileHome.supply.body" />
        </p>
        <NamedLink className={css.cta} name="NewListingPage">
          <FormattedMessage id="LandingPage.mobileHome.supply.cta" />
        </NamedLink>
      </div>
    </section>
  );
};

export default SectionHomeSupply;
